import { useEffect, useState } from 'react';
import api from '../services/api';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import {
  Card, CardBody, CardTitle, CardText, Row, Col, Spinner, Alert, Badge
} from 'reactstrap';

const OrganizationCard = () => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/get-org-details/')
      .then(response => {
        setOrganization(response.data);
        setLoading(false);
      })
      .catch(error => {
        setError('Failed to load organization data.');
        setLoading(false);
      });
  }, []);

  if (loading) return <Spinner color="primary" />;
  if (error) return <Alert color="danger">{error}</Alert>;
  if (!organization) return null;

  return (
    <Card>
      <CardBody>
        <Row>
          {organization.logo_url && (
            <Col md="3" className="text-center">
              <img
                src={organization.logo_url}
                alt="Organization Logo"
                style={{ maxWidth: '100%', maxHeight: '150px', objectFit: 'contain' }}
              />
            </Col>
          )}
          <Col md={organization.logo_url ? '9' : '12'}>
            <CardTitle tag="h4">{organization.name}</CardTitle>
            <CardText><strong>Address:</strong> {organization.address || 'N/A'}</CardText>
            <CardText><strong>Phone:</strong> {organization.phone_number || 'N/A'}</CardText>
            <CardText><strong>Email:</strong> {organization.email || 'N/A'}</CardText>
            <CardText><strong>Booking URL:</strong> <a href={organization.booking_url} target="_blank" rel="noopener noreferrer">{organization.booking_url}</a></CardText>
            {organization.map_url && (
              <CardText>
                <strong>Map:</strong> <a href={organization.map_click_url || organization.map_url} target="_blank" rel="noopener noreferrer">View Map</a>
              </CardText>
            )}
            <CardText><strong>Email Confirmation Wording:</strong> 
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{organization.email_confirmation_wording}</ReactMarkdown>
            </CardText>
            <CardText><strong>Cancellation Policy:</strong>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{organization.cancellation_policy}</ReactMarkdown>
            </CardText>
            <div className="mt-3">
              <Badge color={organization.send_email ? 'success' : 'secondary'} className="me-2">
                Email: {organization.send_email ? 'Enabled' : 'Disabled'}
              </Badge>
              <Badge color={organization.send_sms ? 'success' : 'secondary'}>
                SMS: {organization.send_sms ? 'Enabled' : 'Disabled'}
              </Badge>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default OrganizationCard;
